import { Component, Input, ViewEncapsulation } from '@angular/core';
import {
  MatButtonToggle,
  MatButtonToggleChange,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';

import { SelectOption } from 'src/types';

@Component({
  selector: 'app-column-toggle',
  standalone: true,
  imports: [MatButtonToggleGroup, MatButtonToggle],
  templateUrl: './column-toggle.component.html',
  styleUrl: './column-toggle.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ColumnToggleComponent {
  @Input()
  options: SelectOption[];

  @Input()
  name: string;

  @Input()
  onChange: (value: any) => void;

  @Input()
  value: any;

  get id(): string {
    return `${this.name}-${this.value}`;
  }

  onChangeInner(event: MatButtonToggleChange): void {
    this.onChange(event.value);
  }
}
